export default __webpack_public_path__ + "static/media/img-2.d5533e92.webp";